import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { EncryptStorage } from "encrypt-storage";
import React, { useState } from 'react';
import ActionButton from '../../modules/CustomizeComponent/ActionButton';
import Wysiwyg from './Wysiwyg';

export default function CreateNote(props) {
  const [open, setOpen] = React.useState(false);
  const {setNotes,client_case_id} = props;
  const encryptStorage = new EncryptStorage("secret-key");
  const [changes, setChanges] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
    setShowAlert(false);
  };

  const handleClose = () => {
    setShowAlert(true);
    encryptStorage.removeItem(`autosave_notes_${client_case_id}`);
  };
  const handleCloseForm = () => {
    setOpen(false);
    encryptStorage.removeItem(`autosave_notes_${client_case_id}`);
    setChanges(false);
  };
  
  return (
    <>
          <ActionButton
                type="button"
                className="btn btn-primary"
                onClick={handleClickOpen}>
               NEW/RESUME
            </ActionButton>
   
      <Dialog
           open={open}
           onClose={changes?handleClose:handleCloseForm}
           fullWidth={true}
           maxWidth={'xl'}
           scroll={'paper'}
           aria-labelledby="alert-dialog-title"
           aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
        <DialogContent>
        {showAlert && ( // Show the alert if showAlert state is true
            <div className="alert alert-warning text-center" role="alert" style={{color: 'inherit'}}>
               "Reminder: Don't forget to save your save your notes! Please click "Submit" below to make sure you notes are saved."
              <ActionButton type="button" className="close" onClick={() => setShowAlert(false)}>
                <span aria-hidden="true">&times;</span>
              </ActionButton>
            </div>
          )}
            <Wysiwyg client_case_id={client_case_id} setNotes={setNotes} setOpen={setOpen} handleCloseForm ={handleCloseForm } setChanges={setChanges}/>
        </DialogContent>
      </Dialog>
    </>
  );
}
